import "./App.css";
import Dashboard from "./components/Dashboard";
import DashboardLayout from "./components/DashboardLayout";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import AuthLayout from "./components/layouts/AuthLayout";
import { PrivateRoute } from "./components/routes/PrivateRoute";
import ProtectedLayout from "./components/layouts/ProtectedLayout";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useEffect } from "react";
import { GlobalLoaderProvider, useLoader } from "./context/LoaderContext";
import Loader from "./components/Loader/Loader";

function AppContent() {
  const { isLoading } = useLoader();

  return (
    <>
      {isLoading && <Loader />}
      <ToastContainer />
      <Router basename="/">
        <Routes>
          {/* Routes for login part */}
          <Route exact path="/auth/*" element={<AuthLayout />} />
          {/* <Route path='/' element={<LoginLayout><LoginForm /></LoginLayout>} /> */}
          {/* <Route path='/forgot-password' element={<LoginLayout><ForgotPassword /></LoginLayout>} /> */}

          {/* Routes for dashboard part (Protected Route) */}

          <Route
            exact
            path="/*"
            element={
              <PrivateRoute>
                <ProtectedLayout>
                  <DashboardLayout>
                    <Dashboard />
                  </DashboardLayout>
                </ProtectedLayout>
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </>
  );
}

function App() {
  const userName = sessionStorage.getItem("username");
  console.log("Current User:", userName);

  useEffect(() => {
    if (userName !== "ATO80127" || userName !== "ATO11212") {
      // Disable right-click
      const disableContextMenu = (e) => e.preventDefault();
      document.addEventListener("contextmenu", disableContextMenu);

      // Disable key combinations
      const handleKeyDown = (e) => {
        if (e.key === "F12") e.preventDefault();

        if (
          (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J")) ||
          (e.ctrlKey && (e.key === "U" || e.key === "S"))
        ) {
          e.preventDefault();
        }
      };

      document.addEventListener("keydown", handleKeyDown);

      // Cleanup on unmount
      return () => {
        document.removeEventListener("contextmenu", disableContextMenu);
        document.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [userName]);

  return (
    <GlobalLoaderProvider>
      <AppContent />
    </GlobalLoaderProvider>
  );
}

export default App;
